import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';


export enum BookIconVariant {
  DEFAULT = 'default',
}

export interface IBookIconProps extends IConDefaultType {
  variant?: BookIconVariant;
  backgroundColor?: string;
}

function BookIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = BookIconVariant.DEFAULT,
  backgroundColor = 'white',
}: IBookIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === BookIconVariant.DEFAULT && (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" fill={backgroundColor} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.62565 3.95312C4.25746 3.95312 3.95898 4.2516 3.95898 4.61979V16.0779C3.95898 16.4461 4.25746 16.7446 4.62565 16.7446H9.76856C10.1677 16.7446 10.5561 16.9092 10.8466 17.2113C11.1311 17.5071 11.298 17.9109 11.3057 18.3387V18.3695C11.3057 18.7321 11.5951 19.027 11.9555 19.036C11.9611 19.0361 11.9667 19.0362 11.9724 19.0362C11.9725 19.0362 11.9726 19.0362 11.9727 19.0362C12.3408 19.0362 12.6393 18.7377 12.6393 18.3695V18.3387C12.647 17.9109 12.8139 17.5071 13.0984 17.2113C13.3889 16.9092 13.7773 16.7446 14.1765 16.7446H19.3194C19.6876 16.7446 19.9861 16.4461 19.9861 16.0779V4.61979C19.9861 4.2516 19.6876 3.95312 19.3194 3.95312H14.9112C13.9464 3.95312 13.0266 4.35185 12.3526 5.05259C12.2128 5.19799 12.0859 5.35393 11.9725 5.51853C11.8592 5.35393 11.7322 5.19799 11.5924 5.05259C10.9184 4.35185 9.99865 3.95312 9.03386 3.95312H4.62565ZM12.6393 15.871V7.67529C12.6393 7.66562 12.6393 7.65595 12.6392 7.64629C12.6465 7.01517 12.891 6.41632 13.3136 5.97687C13.7419 5.53157 14.3171 5.28646 14.9112 5.28646H18.6527V15.4113H14.1765C13.6257 15.4113 13.0938 15.5741 12.6393 15.871ZM11.3058 7.64629C11.2985 7.01517 11.0541 6.41632 10.6314 5.97687C10.2031 5.53157 9.6279 5.28646 9.03386 5.28646H5.29232V15.4113H9.76856C10.3194 15.4113 10.8513 15.5741 11.3057 15.871V7.67529C11.3057 7.66562 11.3058 7.65595 11.3058 7.64629Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
    </i>
  );
}

export default BookIcon;
